<git-task-commit *ngIf="(taskGitCommits$ | async).length > 0 && (isInstalled$ | async)"
  [taskCommits]="taskGitCommits$ | async"
  (removeCommit)="onRemove($event)"
>
<git-task-block-title [integrationName]="name"  [title]="'Github Commits'"></git-task-block-title>
</git-task-commit>
